import { DatePipe } from '@angular/common';
import { Component, WritableSignal, effect, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTableModule } from '@angular/material/table';
import { Router, RouterModule } from '@angular/router';
import { NavigationComponent } from '../../components/navigation/navigation.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { DecadePipe } from '../../pipes/decade.pipe';
import { GenderStringPipe } from '../../pipes/gender-string.pipe';
import { MonthStringPipe } from '../../pipes/month-string.pipe';
import { LogService } from '../../services/log.service';
import { Patient } from '../../services/model';
import { PatientsService } from '../../services/patients.service';

@Component({
  selector: 'app-patients',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    DatePipe,
    MatTableModule,
    MonthStringPipe,
    DecadePipe,
    GenderStringPipe,
    MatIconModule,
    MatMenuModule,
    RouterModule,
    NavigationComponent,
  ],
  templateUrl: './patients.component.html',
  styleUrl: './patients.component.scss',
})
export class PatientsComponent {
  private router: Router = inject(Router);
  private patientsService: PatientsService = inject(PatientsService);
  private logger: LogService = inject(LogService);

  patientList: WritableSignal<Patient[]> = this.patientsService.patientList;
  filteredPatientList: WritableSignal<Patient[]> = signal<Patient[]>([]);

  expandedPatient: Patient | null = null;

  tableColumns = ['visibility', 'id', 'gender', 'birth', 'buttons'];
  constructor(public dialog: MatDialog) {
    this.patientsService.getPatients();
    effect(
      () => {
        const patientsCount = this.patientList()?.length ?? -1;
        this.filteredPatientList.set(this.patientList());
        this.logger.log('patients ' + patientsCount);
        // console.log(`effect patientList`, this.patientList());
      },
      { allowSignalWrites: true }
    );
  }

  onClickSearch(input: HTMLInputElement) {
    const filterValue = input.value.trim().toLowerCase();
    this.filteredPatientList.set(
      this.patientList().filter(
        patient => patient.name?.toLowerCase().includes(filterValue) || patient.uid.toLowerCase().includes(filterValue)
      )
    );
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.filteredPatientList.set(
      this.patientList().filter(
        patient => patient.name?.toLowerCase().includes(filterValue) || patient.uid.toLowerCase().includes(filterValue)
      )
    );
  }

  openFirstPatient() {
    const firstPatientInList: Patient = this.filteredPatientList()[0];
    this.router.navigate(['patients/id/' + firstPatientInList._documentId + '/reports/assessments']);
  }

  newPatient() {
    this.router.navigate(['patients/new']);
  }

  deletePatient(patient: Patient) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Wirklich löschen?',
        description: 'Wollen sie den Patienten mit allen Daten und Testungen wirklich löschen?',
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'YES') {
        this.patientsService.deletePatient(patient);
      }
    });
  }

  toggleVisibility(patient: Patient): void {
    if (this.expandedPatient === patient) {
      this.expandedPatient = null;
    } else {
      this.expandedPatient = patient;
    }
  }
}
